import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgDropletIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <path
      fill="currentColor"
      d="M29.315 8c-1.123 1.458-4.457 5.949-7.513 11.686C18.712 25.487 16 32.396 16 38.666 16 48.099 22.227 56 32 56s16-7.902 16-17.333c0-6.272-2.713-13.18-5.803-18.981C39.142 13.949 35.807 9.458 34.684 8zm-2.092-1.653a2.61 2.61 0 0 1 2.08-1.014h5.393c.795 0 1.57.352 2.08 1.014 1.154 1.495 4.605 6.135 7.775 12.085 3.151 5.917 6.115 13.298 6.115 20.235 0 10.568-7.105 20-18.666 20s-18.667-9.432-18.667-20c0-6.937 2.964-14.318 6.116-20.235 3.169-5.95 6.62-10.59 7.774-12.085m14.784 41.004c-1.725 2.45-4.49 4.403-7.53 3.969l.378-2.64c1.627.233 3.53-.815 4.97-2.864 1.418-2.014 2.099-4.622 1.548-6.826l2.587-.647c.782 3.13-.204 6.522-1.953 9.008"
    />
  </svg>
)
export default SvgDropletIcon
